import { render, staticRenderFns } from "./SecSafety_SKMJ.vue?vue&type=template&id=3ee73b23&scoped=true&"
import script from "./SecSafety_SKMJ.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKMJ.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKMJ.vue?vue&type=style&index=0&id=3ee73b23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee73b23",
  null
  
)

export default component.exports